import { EventEmitter } from '@angular/core';
import { ButtonsAssociateDocumentComponent } from '@app/shared';

export class ManageAssociationConfigService {
  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // contiene la configuracion de la tabla
  settings = {};

  constructor () { }

  /**
   * Tabla de documentos de una tarea asociada
   *
   * @memberof ManageAssociationConfigService
   */
  tableOnlyTask() {
    const self = this;
    this.settings = {
      mode: 'external',
      noDataMessage: 'No hay documentos para asociar',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        clasificacion: {
          editable: false,
          addable: false,
          title: 'Nombre documento',
          filter: {
            inputClass: 'form-control',
          },
          sortDirection: 'asc',
        },
        tipo_documental: {
          editable: false,
          addable: false,
          title: 'Tipo documental',
          filter: {
            inputClass: 'form-control',
          },
        },
        clasificacion_id: {
          title: 'Acciones',
          filter: false,
          type: 'custom',
          width: '20%',
          renderComponent: ButtonsAssociateDocumentComponent,
          onComponentInitFunction(instance: any) {
            instance.save.subscribe((data: any) => {
              // controla el evento click del boton
              self.accion.emit(data);
            });
          }
        },
      },
    };
  }

  /**
   * Tabla de documentos asociados de multiples tareas
   *
   * @memberof ManageAssociationConfigService
   */
  tableMultipleTask() {
    const self = this;
    this.settings = {
      mode: 'external',
      noDataMessage: 'No hay documentos para asociar',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        clasificacion: {
          editable: false,
          addable: false,
          title: 'Nombre documento',
          filter: {
            inputClass: 'form-control',
          },
          sortDirection: 'asc',
        },
        tipo_documental: {
          editable: false,
          addable: false,
          title: 'Tipo documental',
          filter: {
            inputClass: 'form-control',
          },
        },
        tramite: {
          editable: false,
          addable: false,
          title: 'Trámite',
          filter: {
            inputClass: 'form-control',
          },
        },
        tarea: {
          editable: false,
          addable: false,
          title: 'Tarea',
          filter: {
            inputClass: 'form-control',
          },
        },
        clasificacion_id: {
          title: 'Acciones',
          filter: false,
          type: 'custom',
          width: '20%',
          renderComponent: ButtonsAssociateDocumentComponent,
          onComponentInitFunction(instance: any) {
            instance.save.subscribe((data: any) => {
              // controla el evento click del boton
              self.accion.emit(data);
            });
          }
        },
      },
    };
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/manage-association/shared/manage-association.config.service.ts